import React from 'react'
import TermsPrivacyDetails from 'src/Components/Customer/TermsPrivacyDetails';
import privacyPolicyImage from 'src/assets/images/website-images/privacy-banner.png';
import { privacyPolicyContent } from 'src/lib/PrivacyData';

const PrivacyPolicy = () => {
    return (
        <div>
            <TermsPrivacyDetails
                image={privacyPolicyImage}
                title="Privacy Policy"
                content={privacyPolicyContent}
            />
        </div>
    )
}

export default PrivacyPolicy;